import { notification } from 'antd'
import { Action } from 'redux'
import { put, takeLatest } from 'redux-saga/effects'
import { rootActions } from '@app-store/slices'
import axios from '@utils/request'
import { IDeleteServicePayload } from '@app-store/slices/services/deleteService'

interface TaskAction extends Action {
    payload: IDeleteServicePayload
}

const { onRequest, onSuccess, onFailure } = rootActions.services.delete

function* deleteServiceSagaTask({ payload }) {
    try {
        const response = yield axios.delete(`/companies/services`, payload.data)
        if (response.success) {
            yield put(onSuccess(response.result))
            notification.success({
                message: 'Service deleted successfully.'
            })
            yield payload.sagaCB?.onSuccess()
        } else {
            throw new Error('')
        }
    } catch (error) {
        yield put(onFailure(error))
    }
}

function* deleteServiceSaga(): any {
    yield takeLatest<TaskAction>(onRequest, deleteServiceSagaTask)
}

export default deleteServiceSaga
